/** @format */

import React from "react";
import { Route, Routes } from "react-router-dom";

import Ptn from "./ptn/index";
import Manbalar from "./manbalar/index";
import Daryolar from "./daryolar/index";

const LimitSahifa = () => {
  return (
    <Routes>
      <Route path='/*' element={<Ptn />} />
      <Route path='/manbalar/*' element={<Manbalar />} />
      <Route path='/daryolar/*' element={<Daryolar />} />
      <Route path='/ptn/*' element={<Ptn />} />
    </Routes>
  );
};

export default LimitSahifa;
